export * from './common';
export * from './order';
export * from './enum';
export * from './activity';
export * from './seat';
export * from './file';
export * from './home';
export * from './card';
export * from './tools';

export enum ClientHostType {
  none = 'null',
  galaxy = 'www.galaxy.com',
  icirena = 'wwww.icirena.ai',
  acx = 'www.acx.ai',
}

export enum LocalStorageKey {
  user = 'user',
  age = 'age',
  lang = 'lang',
  getCaptchaCount = 'getCaptchaCount',
  isSeatTipFirstShow = 'isSeatTipFirstShow',
  canvasId = 'canvasId',
  seatSpliceRuleInfo = 'seatSpliceRuleInfo',
}

export interface LocalStorageValue {
  [LocalStorageKey.user]: 'string';
  [LocalStorageKey.age]: 'age';
  [LocalStorageKey.lang]: 'string';
  [LocalStorageKey.getCaptchaCount]: any;
  [LocalStorageKey.isSeatTipFirstShow]: string;
  [LocalStorageKey.canvasId]: string;
}

export enum SessionStorageKey {
  user = 'user1',
  age = 'age1',
  selectSeatList = 'selectSeatList',
  wxPayOpenId = 'wxPayOpenId',
  wxLoginOpenId = 'wxLoginOpenId',
  wxOpenId = 'wxOpenId',
  orderObj = 'orderObj',
}

export interface SessionStoragesValue {
  [SessionStorageKey.user]: 'string1';
  [SessionStorageKey.age]: 'age1';
  [SessionStorageKey.selectSeatList]: 'string';
  [SessionStorageKey.wxPayOpenId]: {
    openid: string;
    time: number;
  };
  [SessionStorageKey.wxLoginOpenId]: {
    openid: string;
    time: number;
  };
  [SessionStorageKey.orderObj]: any;
}

export enum UserType {
  GALAXY = 'galaxy',
  ICIRENA = 'icirena',
}

export type AnyFunction = (...args: any[]) => any;

export interface addEventerType {
  event: string;
  element: HTMLElement | Window;
  listener: AnyFunction;
  others?: any;
}

/**
 * @desc http 状态码
 */
export enum HTTP_STATUS {
  SUCCESS = '0',
}

export enum GOP_BIZCODE {
  LOGINEXPIREND = '20001',
  CHANNELERROE = '2011',
  LOGINTIMEOUT = '1002',
  SALE_STATUS_IS_NOT = 'SALE_STATUS_IS_NOT',
  TICKET_INFO_IS_NOT = '2320',
  SUCCESS = '0',
}

export enum LANGUAGE {
  'zh-CN' = '简体中文',
  'zh_CN' = '简体中文',
  'zh-TW' = '繁體中文',
  'zh_TW' = '繁體中文',
  'en-US' = 'English',
  'en' = 'English',
}

/**
 * @desc 登陆面板类型
 */
export enum PANEL_TYPE {
  CAPTCHALOGIN = 'ACCOUNT_LOGIN',
  PASSWORDLOGIN = 'PASSWORD_LOGIN',
  RESETPASSWORD = 'ACCOUNT_RESET_PASSWORD',
  BINDEMAIL = 'ACCOUNT_BIND_EMAIL',
  BINDMOBILE = 'ACCOUNT_BIND_MOBILE',
  BIND = 'ACCOUNT_BIND',
  RESETCARD = 'FHJY_SMS_PASSWORD_UPDATE',
  BINDCARD = 'MEMBER_CARD_BIND',
  WXBIND = 'WX_BIND',
  WXBINDMOBILE = 'WX_BIND_MOBILE',
  WXBINDEMAIL = 'WX_BIND_EMAIL',
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
}

/**
 * @desc 登陆面板类型
 * @enum TOAST 提示
 * @enum DIALOG 对话
 * @enum CONFIRM 确认按钮
 * @enum ANY 自定义内容
 * @enum NULL 未知初始
 */
export enum ALERT_TYPE {
  TOAST,
  DIALOG,
  ANY,
  CONFIRM,
  NULL,
}

export enum PayStatusEnum {
  SUCCESS = 'PAY_SUCCESS', // 付款成功
  FAIL = 'PAYED_FAIL', // 付款失败
  WAIT = 'PAY_WAIT', // 待支付
  PAY_WAIT = 'PAY_WAIT', // 待支付
  CANCEL = 'ORDER_CANCEL', // 订单取消
  CLOSE = 'ORDER_CLOSE', // 订单关闭
  NONE = 'NONE',
  PAY_REFUND_FAIL = 'PAY_REFUND_FAIL', // 退款失败
  PAY_REFUND_SUCCESS = 'PAY_REFUND_SUCCESS', // 退款成功
  PAY_REFUND_SUCCESS_PARTLY = 'PAY_REFUND_SUCCESS_PARTLY', // 部分退款成功
  PAY_REFUNDING = 'PAY_REFUNDING', // 退款中
  PAY_REFUNDING_PARTLY = 'PAY_REFUNDING_PARTLY', // 部分退款中
  PAY_REFUND_FAIL_PARTLY = 'PAY_REFUND_FAIL_PARTLY',
}

export enum TicketStatusEnum {
  TICKET_WAIT = 'TICKET_WAIT', // 出票中
  TICKET_SUCCESS = 'TICKET_SUCCESS', // 出票成功
  TICKET_FAIL = 'TICKET_FAIL', // 出票失败
  TICKET_HAS_PICKUP = 'TICKET_HAS_PICKUP', // 已取票
  TICKET_REFUNDING = 'TICKET_REFUNDING', // 退票中
  TICKET_REFUND_SUCCESS = 'TICKET_REFUND_SUCCESS', // 退票成功
  TICKET_REFUND_FAIL = 'TICKET_REFUND_FAIL', // 退票失败
  TICKET_HAS_SHOWN = 'TICKET_HAS_SHOWN', // 已放映
}

export enum PayInfoSource {
  CREATED = 'created',
  DETAIL = 'detail',
  NONE = 'none',
}

export enum MutualEnum {
  // 促销码
  PROMO_CODE,
  // 会员号
  MEMBER_NUMBER,
  // aia
  AIA_EXCHANGE,
  // 活动/会员卡
  ACTIVITY_CARD,
  // 优惠卷
  COUPON,
  // aia健康
  AIA_VITALITY,
}

/**
 * @desc 设备类型
 * @H5 h5
 * @PAD pad
 * @PC 电脑
 */
export enum DEVICE_TYPE {
  // 促销码
  H5 = 'H5',
  // 会员号
  PAD = 'PAD',
  // aia
  PC = 'PC',
}

/**
 * @ROUTER_MAP 路由跳转
 * @HOME 首页
 * @SCREEN 场次页
 * @SEAT 选座页
 * @ORDER_CONFIRM 确认订单
 * @PAYMENT 支付页
 * @PAYMENT_RESULT 支付结果/订单详情
 * @POINT_MYPOINT 我的积分
 * @POINT_STORE 积分商城
 * @POINT_DETAIL 积分商品详情
 * @POINT_COMPLETE 积分兑换成功页
 * @POINT_ORDER 积分兑换记录
 * @POINT_ORDERDETAIL 积分兑换记录详情
 * @COUPON_DETAIL 优惠券详情
 * @COUPON_LIST 优惠券列表
 * @AGREEMENT_LIST 协议列表
 * @AGREEMENT_PRIVACY 协议详情
 */
export enum ROUTER_MAP {
  HOME = '/',
  SCREEN = '/showtimes',
  SEAT = '/seat',
  FILM = '/film',
  ORDER_CONFIRM = '/order/confirm',
  ORDER_LIST = '/order/list',
  PAYMENT = '/payment',
  PAYMENT_RESULT = '/payment/result',
  USER_INDEX = '/user',
  ACTIVITY_AND_VIP = '/activityAndVip',
  ACTIVITY_DETAIL = '/activity/detail',
  CINEMA_DETAIL = '/cinema/detail',
  POINT_MYPOINT = '/point/myPoint',
  POINT_STORE = '/point/store',
  POINT_DETAIL = '/point/detail',
  POINT_COMPLETE = '/point/complete',
  POINT_ORDER = '/point/order',
  POINT_ORDERDETAIL = '/point/orderDetail',
  COUPON_DETAIL = '/coupon/detail',
  COUPON_LIST = '/coupon/list',
  AGREEMENT_LIST = '/agreement/list',
  AGREEMENT_PRIVACY = '/agreement/privacy',
  CARD_COMPLETE = '/card/complete',
  CARD_PRIVILEGE = '/card/privilege',
  CARD_BIND = '/payment/cardApply',
  CARD_LIST = '/card/list',
  CARD_SELL = '/card/sell',
}

export enum OrderType {
  TICKET = 'TICKET',
  GOODS = 'GOODS',
  MIX = 'TICKET_GOODS',
  CARD = 'CARD',
}

/**
 * @ORDERCATEGORYTYPE 订单类型
 * @TICKET 1：影票订单
 * @GOODS 2：卖品订单
 * @CARD 3：会员卡订单
 * @MIX 4:影票卖品混合订单
 */
export enum ORDERCATEGORYTYPE {
  TICKET = '1',
  GOODS = '2',
  CARD = '3',
  MIX = '4',
}
/**
 * @CardType 会员卡类型
 * @CHUZHIKA 储值卡
 * @QUANYIKA 权益卡
 */
export enum CardType {
  CHUZHIKA = 'V',
  QUANYIKA = 'A',
}
/**
 * @CardStatus 会员卡状态
 * @EXPIRES 过期
 * @UNACTIVATED 未激活
 */
export enum CardStatus {
  EXPIRES = 'T',
  UNACTIVATED = 'UA',
}
